import { render, staticRenderFns } from "./Ministerios.vue?vue&type=template&id=1b5d7147&scoped=true&"
import script from "./Ministerios.vue?vue&type=script&lang=js&"
export * from "./Ministerios.vue?vue&type=script&lang=js&"
import style0 from "./Ministerios.vue?vue&type=style&index=0&id=1b5d7147&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d7147",
  null
  
)

export default component.exports